// Per-device conveniences only (DEC-032), namespaced by tenant and project so two
// projects on one hostname never overwrite each other (DEC-023).
const key = (tenant, project, name) => `pot:${tenant}:${project}:${name}`;

export function remember(tenant, project, name, value) {
  try {
    localStorage.setItem(key(tenant, project, name), JSON.stringify(value));
  } catch {
    /* storage blocked: the app works without it */
  }
}

export function recall(tenant, project, name, fallback) {
  try {
    const raw = localStorage.getItem(key(tenant, project, name));
    return raw == null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
}
